<template>
    <div id="bene-bank-transfer-container">
        <f7-list form class="form-group" v-if="showFormSet.bankTransfer">
            <f7-list-input
                input-id     ="ifscCode"
                name         ="ifscCode"
                type         ="text"

                v-if         ="showFormInput.bankTransfer.ifscCode"
                :label       ="$t('beneficiary-ifsc-code')"
                :placeholder ="$t('beneficiary-ifsc-code')"
                :value       ="ifscCode"
                @change      ="setIfscCode($event.target.value); validateInput($event.target); setInput('ifscCode');"

                maxlength    ="11"
                autocomplete ="off"
                outline
                floating-label
                clear-button
            ></f7-list-input>

            <f7-list-input
                input-id     ="ifscBankBranch"
                name         ="ifscBankBranch"
                type         ="text"

                v-if         ="showFormInput.bankTransfer.ifscBankBranch"
                :label       ="$t('beneficiary-ifsc-bank-branch')"
                :placeholder ="$t('beneficiary-ifsc-bank-branch')"
                :value       ="ifscBankBranch"
                @change      ="setIfscBankBranch($event.target.value); validateInput($event.target); setInput('ifscBankBranch');"

                autocomplete ="off"
                outline
                floating-label
                clear-button
            ></f7-list-input>
        </f7-list>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    export default {
        props: {
        },
        mounted() {
        },
        data: function() {
            return {
            }
        },
        computed: {
            ...mapGetters('beneficiary', [
                'showFormSet',
                'showFormInput',
                'ifscCode',
                'ifscBankBranch',
                'isbKashTx',
                'showPreloaderState',
                'forceRerenderKey',
                'isCreateBeneficiary',
            ])
        },
        components: {
        },
        methods: {
            ...mapActions('beneficiary', [
                'setIfscCode',
                'setIfscBankBranch',
                'setShowPreloaderState'
            ]),

            validateInput(inputEl){
                this.$emit("validateInput", inputEl);
            },

            setInput(inputEl){
                this.$emit("setInput", inputEl);
            }
        }
    }
</script>